export const SEMANTIC_SEARCH_AMPLITUDE_LOCATION = "rp_ai_chat";

export const SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT = "rp_semantic_search_auth";
export const SEMANTIC_SEARCH_AMPLITUDE_LOCATION = "rp_ai_chat";

export const SEMANTIC_SEARCH_AMPLITUDE_AUTH_PLACEMENT = "rp_semantic_search_auth";
